import { TextField } from '@mui/material';
import { KeyboardEvent } from 'react';
import { InputType } from './../EditComponent';

interface TextEditComponentProps {
  label: string;
  localVal: InputType;
  handleSave: (
    value: InputType,
    e?: KeyboardEvent<HTMLDivElement> | KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
    displayValue?: string
  ) => void;
  handleClose: () => void;
  change?: (v: string | number | null) => void;
  isTextarea: boolean;
  setLocalVal: (v: InputType) => void;
}

export const TextEditComponent = ({
  label,
  handleSave,
  handleClose,
  change,
  isTextarea,
  localVal,
  setLocalVal
}: TextEditComponentProps) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement> | KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && (!isTextarea || e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      handleSave(undefined, e);
    }
  };

  return (
    <TextField
      type="text"
      multiline={isTextarea}
      minRows={isTextarea ? 6 : 1}
      sx={isTextarea ? { width: '100%' } : {}}
      role="textbox"
      variant="outlined"
      onChange={(e) => {
        setLocalVal(e.target.value);
        change && change(e.target.value);
      }}
      value={localVal || ''}
      name="text_input"
      slotProps={{
        htmlInput: {
          'data-testid': `${label.replace(' ', '-').toLowerCase()}-${isTextarea ? 'textarea' : 'text'}-field`
        }
      }}
      inputRef={(input) => input && input.focus()}
      size="small"
      onBlur={(e) => !isTextarea && handleSave(e.target.value)}
      onKeyDown={handleKeyDown}
    />
  );
};
